export const vehiclesColumns = [
  { id: 'estado', label: 'Estado', type: 'select', sortable: true, required: true, options: [
    { value: 'Activo', label: 'Activo' },
    { value: 'Inactivo', label: 'Inactivo' },
  ] },
  { id: 'nombre', label: 'Nombre', type: 'text', sortable: true, required: true },
  { id: 'placa', label: 'Placa', type: 'text', sortable: true, required: false },
  { id: 'marca', label: 'Marca', type: 'text', sortable: true, required: true },
  { id: 'kilometraje', label: 'Kilometraje', type: 'number', sortable: true, required: true },
  { id: 'color', label: 'Color', type: 'text', sortable: true, required: true },
  { id: 'descripcion', label: 'Descripción', type: 'text', sortable: false, required: false },
];

export const columnsExcel = vehiclesColumns.map(col => ({
  key: col.id,
  header: col.label,
}));
